import React from 'react';
import PropTypes from 'prop-types';

import LayoutHeader from '../LayoutHeader';
import LayoutFooter from '../LayoutFooter';
import LayoutContent from '../LayoutContent';

import styles from './index.styl';

export { LayoutHeader as Header };
export { LayoutFooter as Footer };
export { LayoutContent as Content };

export default function Layout(props) {
  return (
    <div className={styles.layout}>
      {props.children}
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
};

/**
 * Оставляем экспорт через статическое свойство в качестве обратой
 * совместимости, но лучше использовать нормальный ES6 экспорт.
 */
Layout.Header = LayoutHeader;
Layout.Footer = LayoutFooter;
Layout.Content = LayoutContent;
